<div class="dsg-palette">
  <div class="dsg-palette-search">
    <mat-icon aria-hidden="true">search</mat-icon>
    <input
      type="text"
      placeholder="Search objects"
      [ngModel]="search()"
      (ngModelChange)="search.set($event)"
      aria-label="Search components"
    />
    <button
      *ngIf="search()"
      type="button"
      class="dsg-palette-search-clear"
      (click)="search.set('')"
      aria-label="Clear search"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dsg-palette-scroll">
    <p class="dsg-palette-empty" *ngIf="isEmpty()">No components match that search.</p>

    <section
      class="dsg-palette-section"
      *ngFor="let section of sections(); trackBy: trackBySection"
    >
      <h4 class="dsg-palette-section-title">{{ section.label }}</h4>

      <div class="dsg-palette-grid">
        <button
          *ngFor="let item of section.items; trackBy: trackByKey"
          type="button"
          class="dsg-palette-item"
          [class.is-active]="isActive(item)"
          draggable="true"
          [matTooltip]="item.hint || item.label"
          matTooltipShowDelay="400"
          (dragstart)="onDragStart(item, $event)"
          (click)="onPick(item)"
        >
          <mat-icon aria-hidden="true">{{ item.icon }}</mat-icon>
          <span class="dsg-palette-item-label">{{ item.label }}</span>
        </button>
      </div>
    </section>
  </div>

  <p class="dsg-palette-hint">Drag onto the canvas, or click then drag to draw.</p>
</div>
